import { jsonFromDocument } from "cerulean";

const useUserConfiguration = () => {
  const currentUser = jsonFromDocument("current_user") || {};

  return {
    currentUser,
    permissions: jsonFromDocument("user_permissions"),
  };
};

export default useUserConfiguration;
